import React from 'react'
import { useTranslation } from 'react-i18next'
import '../../i18n'
import { TypeActionTranslations } from '../../utils/constants'

interface ProjecTypeTagProps {
  value: string
}

const ProjecTypeTag: React.FC<ProjecTypeTagProps> = ({ value }) => {
  const { t } = useTranslation()

  return (
    <div
      style={{
        padding: '2px 10px',
        borderRadius: '5px',
        fontSize: '15px',
        color: '#222831',
        display: 'inline-block',
        backgroundColor: '#f2f2f2',
      }}
    >
      {t(TypeActionTranslations[value] || value)}
    </div>
  )
}
export default ProjecTypeTag
